<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.log')">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('common.nodata')" />
        <div v-else class="record-list">
          <div class="record-card" v-for="(item,i) in list" :key="i">
            <div class="record-top">
              <div class="left">
                <p class="money-line">残高の引き出しし{{item.money}}JPY</p>
                <p class="time-line">{{item.create_time}}</p>
              </div>
              <p class="status-line status-fail">{{statusExt[item.status]}}</p>
            </div>
            <div class="notice-block" v-if="item.desc">
              <p class="notice-title">{{$t('notification')}}</p>
              <p class="notice-content">{{item.desc}}</p>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
import { Dialog } from 'vant';
export default {
  data() {
    return {
	  page:1,
	  isLoading: false,
	  count:0,
	  limit:10,
	  loading: false,
	  finished: false,
	  refreshing: false,
      list:[],
	  statusExt:['',this.$t('withdraw.status1'),this.$t('withdraw.status2'),this.$t('withdraw.status3')],
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.isLoading = false;
        this.getUserWithdrawList();
      }, 500);
    },
	showD(desc){
		Dialog.alert({
		  title: this.$t('notification'),
		  message: desc,
		  messageAlign: 'left',
		  className: 'withdraw-notification-dialog',
		  // on close
		});
	},
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 1rem;
}

::v-deep .van-loading__text {
  color: #aaa;
  font-size: 1rem;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 6px;
}

.record-list {
  padding: 6px 0 16px;
}

.record-card {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 6px;
  padding: 10px 8px;
}

.record-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.record-top .left {
  flex: 1;
  text-align: left;
}

.money-line {
  margin: 0;
  font-size: 1.05rem;
  color: #2e2fa8;
  line-height: 1.2;
}

.time-line {
  margin: 2px 0 0;
  font-size: .95rem;
  color: #8d8d8d;
}

.status-line {
  margin: 0;
  font-size: 1.05rem;
  white-space: nowrap;
  padding-left: 10px;
}

.status-fail {
  color: #ff6a6a;
}

.notice-block {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #ececf4;
}

.notice-title {
  margin: 0;
  color: #ff6a6a;
  font-weight: 600;
}

.notice-content {
  margin: 2px 0 0;
  color: #222;
  font-size: 1.15rem;
}

/* 通知弹窗文字样式 - 使用全局样式确保生效 */
</style>

<style lang='less'>
/* 通知弹窗文字样式 - 全局样式，不使用 scoped */
.van-dialog.withdraw-notification-dialog .van-dialog__content .van-dialog__message,
.van-dialog.withdraw-notification-dialog .van-dialog__message.van-dialog__message--has-title,
.van-dialog.withdraw-notification-dialog .van-dialog__message.van-dialog__message--left,
.van-dialog.withdraw-notification-dialog .van-dialog__message,
.withdraw-notification-dialog .van-dialog__message {
    font-size: 1rem !important;
    line-height: 2.2 !important;
    color: #323233 !important;
    padding: 25px !important;
    word-break: break-word;
    text-align: left !important;
    font-weight: 600 !important;
    min-height: auto !important;
}

.van-dialog.withdraw-notification-dialog .van-dialog__content {
    padding: 20px !important;
}
</style>